import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import PlaylistAddOutlinedIcon from "@mui/icons-material/PlaylistAddOutlined";
import GridOnIcon from "@mui/icons-material/GridOn";
import HistoryIcon from '@mui/icons-material/History';
import UpdateIcon from "@mui/icons-material/Update";
import StorageIcon from '@mui/icons-material/Storage'; // Pour Hébergement
import AssessmentIcon from '@mui/icons-material/Assessment'; // Pour TMA

import SidebarLayout, { MenuGroup } from "./SidebarLayout";

// Section "Chiffrage Projets" : uniquement les pages liées aux projets/TMA/hébergements/matrices.
// Navette de paie et Matrice Régie sont des sections complètement séparées (voir LayoutPayroll,
// LayoutRegie) — elles ne doivent pas apparaître ici.
const menuData: MenuGroup[] = [
    {
        groupName: "Projets",
        items: [
            { icon: <ListOutlinedIcon />, text: "Projets", page: "/projets" },
            { icon: <PlaylistAddOutlinedIcon />, text: "Ajouter un projet", page: "/projets/ajout" },
        ],
    },
    {
        groupName: "TMA",
        items: [
            { icon: <AssessmentIcon />, text: "Liste des TMA", page: "/TMA" },
        ],
    },
    {
        groupName: "Hébergements",
        items: [
            { icon: <StorageIcon />, text: "Hébergements", page: "/hebergement" },
            { icon: <UpdateIcon />, text: "Prix OVH", page: "/hebergement/ovh-prices" },
        ],
    },
    {
        groupName: "Matrices",
        items: [
            { icon: <GridOnIcon />, text: "Liste des matrices", page: "/matrices" },
        ],
    },
    {
        groupName: "Historique",
        items: [
            { icon: <HistoryIcon />, text: "Historique", page: "/history" },
        ],
    },
];

export default function LayoutPricing() {
    return <SidebarLayout menuData={menuData} />;
}
